export default "__VITE_ASSET__StOZTJ3M__"